import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-question-bank',
    templateUrl: './question-bank.component.html',
    styleUrls: ['./question-bank.component.css'],
    standalone: false
})
export class QuestionBankComponent {

  subjects = [
    {
      subjectName: "MATHMATICS",
      packs: [
        {
          packName: "Starter",
          class: "s",
          packImg: "assets/images/maths-s.jpg",
          packDes: "carefully structured 11+ Math's questions",
          totalQuestions: "560",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/4992edcab0992ee492045c519635df68"
        },
        {
          packName: "Mastery",
          class: "m",
          packImg: "assets/images/maths-m.jpg",
          packDes: "high-level 11+ Math's questions",
          totalQuestions: "1120",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/056d89758c709967893a7734162ba367"
        },
        {
          packName: "All in One",
          class: "a",
          packImg: "assets/images/maths-a.jpg",
          packDes: "expertly crafted 11+ Math's questions",
          totalQuestions: "1680",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/b540f9fea7c24be9352f39cda30a1006"
        }
      ]
    },

      {
      subjectName: "VERBAL REASONING (VR)",
      packs: [
        {
          packName: "Starter",
          class: "s",
          packImg: "assets/images/vr-s.jpg",
          packDes: " carefully structured 11+ NVR questions ",
          totalQuestions: "620",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/a584bc99b84091445c3a3cb6c51c747c"
        },
        {
          packName: "Mastery",
          class: "m",
          packImg: "assets/images/vr-m.jpg",
          packDes: " challenging questions designed for advanced 11+ preparation",
          totalQuestions: "1240",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/283b4ef68fd77030a910530cc16c0d62"
        },
        {
          packName: "All in One",
          class: "a",
          packImg: "assets/images/vr-a.png",
          packDes: " expertly designed questions (Starter + Mastery)",
          totalQuestions: "1860",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/e3ddef91ba69f292a001dc49e5c69b95"
        }
      ]
    },
     {
      subjectName: "NON VERBAL REASONING (NVR)",
      packs: [
        {
          packName: "Starter",
          class: "s",
          packImg: "assets/images/nvr-s.jpg",
          packDes: " carefully structured 11+ NVR questions ",
          totalQuestions: "520",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/cd339c461bf1e5d0b079d884c37347c6"
        },
        {
          packName: "Mastery",
          class: "m",
          packImg: "assets/images/nvr-m.jpg",
          packDes: " challenging questions designed for advanced 11+ preparation",
          totalQuestions: "1040",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/600a554c8c3f1249653cb44749a64e78"
        },
        {
          packName: "All in One",
          class: "a",
          packImg: "assets/images/nvr-a.jpg",
          packDes: " expertly designed questions (Starter + Mastery)",
          totalQuestions: "1560",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/600a554c8c3f1249653cb44749a64e78"
        }
      ]
    },

    {
      subjectName: "ENGLISH",
      packs: [
        {
          packName: "Starter",
          class: "s",
          packImg: "assets/images/eng-s.jpg",
          packDes: "carefully structured 11+ english questions",
          totalQuestions: "1100",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/47261524531f01e5239857a7cb4818f2"
        },
        {
          packName: "Mastery",
          class: "m",
          packImg: "assets/images/eng-m.jpg",
          packDes: "challenging questions designed for advanced 11+ preparation ",
          totalQuestions: "2200 ",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/ae7be1ae34d71a341f0e2e126707adc0"
        },
        {
          packName: "All in One",
          class: "a",
          packImg: "assets/images/eng-a.jpg",
          packDes: "expertly designed questions (Starter + Mastery)",
          totalQuestions: "3300",
          qbLink: "https://www.sehyog.co.uk/11plus-help-club/category/offers/47261524531f01e5239857a7cb4818f2"
        }
      ]
    },
  ]
}
